import { isAdminLabelAA } from '../../../../../services/AccountService'
import { RequestType } from '../../../types/Request.type'

const avaliableChangeDealerStatuses = [1, 2, 4, 7, 11]
const avaliableChangeStatusStatuses = [1, 2, 4, 5, 6, 7, 9, 11]
const avaliableChangePaymentStatuses = [1, 2]
const changeInstallationDataStatuses = [5, 9, 13]
const withoutDCS2InstallationEdit = [6, 13]
export const changeInstallationDataLableAA = [4, 102, 200]

export const getFeatureState = (
  request: RequestType,
  backRoute: string | null,
): Record<string, any> => {
  const state = {
    dontChangeInstallationData:
      request.status === 13 &&
      request.dataCheckingStatus === 3 &&
      [3].includes(request.reportStatus ?? -1),
    // видеть данные отчета
    canSeeReportData: request.reportId,
    disableGoToReportBnt: !!backRoute?.includes('/reports/'),
    disableEditReport:
      request.dataCheckingStatus === 3 && request.reportStatus === 3,
    // редактирование данных заявки в отчете
    canEditReport: false,
    // видеть данные установки
    installationData: !!request.installationDate || !!request.equipmentId,
    // тип оплаты выбран
    isPaymentSelected:
      !!request.financialSourceId && request.financialSourceId !== 4,
    // можем менять дилера
    canChangeDealer: avaliableChangeDealerStatuses.includes(request.status),
    //  можем менять статус
    canChangeStatus: avaliableChangeStatusStatuses.includes(request.status),
    // можем менять тип оплаты
    canChangePaymentType: avaliableChangePaymentStatuses.includes(
      request.status,
    ),
    //  можем редактировать данные установки
    canChangeInstallationData:
      changeInstallationDataStatuses.includes(request.status) ||
      (withoutDCS2InstallationEdit.includes(request.status) &&
        request.dataCheckingStatus !== 2),
    //  можем редактировать данные установки (дополнительно для лэйбла АА)
    canChangeInstallationDataLabelAA:
      isAdminLabelAA() &&
      changeInstallationDataLableAA.includes(request.reportStatus ?? -1),
    showCommentField: false,
    showInstallationData: false,
    // показываем кнопку открытия дровера комментариев
    canPostComments: ![15, 16].includes(request.status),
  }

  state.showInstallationData =
    state.installationData || state.canChangeInstallationData

  state.canEditReport = request.status === 13 && !state.disableEditReport

  state.showCommentField =
    state.canEditReport &&
    request.dataCheckingStatus !== 2 &&
    !!backRoute?.includes('/reports/')

  return state
}
